import React, { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';

// import isEmpty from 'lodash-es/isEmpty';

import { SSO_STATUS, useSso } from '@ecp/common/src/hooks/useSso';
import { VerticalDivider } from '@ecp/common/src/layouts/flex/styled';
import { TextButton } from '@ecp/common/src/components/button/TextButton';

import { userInfoState } from '@bo-recoil/common/user/atom';
import SelectJobGroupPopup from '../../common/popup/SelectJobGroupPopup';
// import { MOCK_SSO_INFOS, MOCK_SSO_USER_INFO_DAHAN_MULTI } from '@bo-const/common/auth';

const AuthWrapper = () => {
  const { connect, status, getOnlySocketResponse, socketResponseData } = useSso({});

  const [showJobGroupSelectPopup, setShowJobGroupSelectPopup] = useState(false);

  const [memberInfo] = useRecoilState(userInfoState);
  const [ssoUserInfo, setSsoUserInfo] = useState();

  // const mockUserInfo = useMemo(() => {
  //   const info = MOCK_SSO_INFOS.filter((info) => info.epUserId === memberInfo?.epUserId);
  //   return isEmpty(info) ? MOCK_SSO_USER_INFO_DAHAN_MULTI : info[0];
  // }, [memberInfo]);

  useEffect(() => {
    if (memberInfo?.multiAuth && connect) {
      connect();
    }
  }, [connect, memberInfo]);

  useEffect(() => {
    switch (status) {
      case SSO_STATUS.READY:
        getOnlySocketResponse();
        break;
      case SSO_STATUS.SUCCESS:
        setSsoUserInfo(socketResponseData);
        break;
      case SSO_STATUS.FAIL:
        // TODO. Mock data에서 가져온다. 이것은 개발완료 후 삭제한다.
        // setSsoUserInfo(mockUserInfo);
        break;
      case SSO_STATUS.CLOSED:
        break;
      default:
        return;
    }
  }, [getOnlySocketResponse, socketResponseData, status]);

  const handleJobGroupChangeBtnClick = () => {
    setShowJobGroupSelectPopup(true);
  };

  return (
    <>
      {memberInfo?.multiAuth && (
        <>
          <VerticalDivider height="6px" />
          <TextButton textProps={{ weight: 400 }} onClick={handleJobGroupChangeBtnClick}>
            권한변경
          </TextButton>
          <SelectJobGroupPopup
            open={showJobGroupSelectPopup}
            onConfirm={() => {
              setShowJobGroupSelectPopup(false);
            }}
            onClose={() => {
              setShowJobGroupSelectPopup(false);
            }}
            ssoUserInfo={ssoUserInfo}
          />
        </>
      )}
    </>
  );
};

export default AuthWrapper;
